import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Subject } from 'rxjs';
import { get } from 'lodash';
import { DateTime } from 'luxon';
import { SCREEN_LAYOUT, ScreenLayout } from '../core/layout/layout.provider';
import { DataService } from '../data/data.service';
import { PickedUpResponse, Pickup, ProductVariant } from '../data/models';
import { PrinterService } from '../data/printer.service';
import { ConfirmDeleteComponent } from '../core/components/confirm-delete.component';


interface PickedupLoadingOptions {
  page: number;
}

export interface PickupViewModel {
  id: number;
  code?: string;
  email: string;
  name: string;
  pickupAt: DateTime | null;
  pickedAt?: DateTime | null;
  rawPickup: Pickup;
  items: PickupItemViewModel[];
  isReservation?: boolean | null;
  expiresAt?: DateTime | null;
  expanded: boolean;
}

export interface PickupItemViewModel {
  product: {
    id: number;
    code: string | null;
    title: string | null;
    imageUrl: string | undefined;
    quantity: number;
    price: string | null;
  };
  options: string[];
}

@Component({
    selector: 'app-reservations',
    styles: [`
    :host {
      display: flex;
      width: 100%;
      height: 100%;

      flex: 1 1 auto;
      flex-direction: column;
      flex-wrap: nowrap;
    }

    .empty-list {
      font-size: 100px;
      opacity: .1;
    }

    .reservation-text{
      width: 63%;
      font-size: 25px;
    }

    #pills-tab {
      margin-left: 16px;
      margin-top: 16px;
    }

    .tab-content > .active {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      flex-shrink: 1;
      height: 100%;
    }

    .no-items-content {
      margin-top: -70px;
    }
  `],
    template: `
    <ng-template #templateRef>
      <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="offen-tab"
            data-bs-toggle="pill"
            data-bs-target="#offen"
            type="button"
            role="tab"
            aria-controls="offen"
            [attr.aria-selected]="activeTab === 'offen'"
            [class.active]="activeTab === 'offen'"
            (click)="activeTab = 'offen'"
          >
            Offen
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="abgeholt-tab"
            data-bs-toggle="pill"
            data-bs-target="#abgeholt"
            type="button"
            role="tab"
            aria-controls="abgeholt"
            [attr.aria-selected]="activeTab === 'abgeholt'"
            [class.active]="activeTab === 'abgeholt'"
            (click)="activeTab = 'abgeholt'"
          >
            Abgeholt
          </button>
        </li>
      </ul>

      <section class="tab-content overflow-y-auto flex-grow-1 flex-shrink-1 h-100 list-group rounded-top-0" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="offen"
          role="tabpanel"
          aria-labelledby="offen-tab"
          [class.show]="activeTab === 'offen'"
          [class.active]="activeTab === 'offen'"
        >
          <app-infinite-scroll
            class="rounded-top-0 flex-grow-1 h-100 flex-shrink-1 overflow-y-auto"
            (scrolled)="loadNextPagePickupsAndReservations()"
            *ngIf="(pickupsAndReservations && pickupsAndReservations.length > 0); else noItemsContent"
          >
            <section class="d-flex flex-column list-group">
              <app-pickup-item
                class="cursor-pointer list-group-item list-group-item-action border-bottom border-top-0 border-start-0 border-end-0"
                [class.reservation-item]="pickupReservation.isReservation"
                *ngFor="let pickupReservation of pickupsAndReservations" 
                [item]="pickupReservation"
                [class.list-group-item-info]="selectedItem?.id === pickupReservation.id"
                (click)="selectedItem = pickupReservation"
              ></app-pickup-item>
            </section>
          </app-infinite-scroll>

          <section
            class="flex-grow-0 flex-shrink-0 d-flex mx-4 my-2"
            [class.justify-content-center]="layout === 'mobile'"
            [class.justify-content-end]="layout === 'desktop'"
            [appLoadingOverlay]="buyingReservedArticle"
            *ngIf="!pickupSelected"
          >
            <button
              type="button"
              class="btn btn-sm btn-rounded-icon btn-light-danger me-1"
              [disabled]="!selectedItem?.isReservation"
              (click)="deleteReservation()"
            >
              <span class="material-icons md-24">delete_forever</span>
            </button>
          
            <button
              class="btn btn-info btn-lg text-white"
              [disabled]="!selectedItem || buyingReservedArticle"
              (click)="buyReservedProduct()"
              i18n
            >
              Abholung
            </button>
          </section>
        </div>

        <div
          class="tab-pane fade"
          id="abgeholt"
          role="tabpanel"
          aria-labelledby="abgeholt-tab"
          [class.show]="activeTab === 'abgeholt'"
          [class.active]="activeTab === 'abgeholt'"
        >
          <app-infinite-scroll
            class="rounded-top-0 flex-grow-1 h-100 flex-shrink-1 overflow-y-auto"
            (scrolled)="loadNextPage()"
            *ngIf="pickedups && pickedups.length > 0; else noItemsContent"
          >
            <section class="d-flex flex-column list-group">
              <app-pickup-item
                class="list-group-item border-bottom border-top-0 border-start-0 border-end-0"
                *ngFor="let pickedup of pickedups"
                [item]="pickedup"
              ></app-pickup-item>
            </section>
          </app-infinite-scroll>
        </div>
      </section>
    </ng-template>

    <ng-template #noItemsContent>
      <section class="flex-grow-1 flex-shrink-1 h-100 d-flex justify-content-center align-items-center no-items-content">
        <span class="d-flex w-100 flex-column align-items-center">
          <span class="material-icons empty-list user-select-none">remove_shopping_cart</span>
          <span class="text-muted fs-4" *ngIf="layout === 'desktop'" i18n>
            {{noDataText}}
          </span>
          <span class="reservation-text text-muted text-center mx-auto" *ngIf="layout === 'mobile'" i18n>
            {{noDataText}}
          </span>
        </span>
      </section>
    </ng-template>

    <ng-template #pickupConfirmRef>
      <app-pickup-overview *ngIf="isPickupViewModel(selectedItem)" [item]="selectedItem"
                           class="overflow-y-auto flex-grow-1 flex-shrink-1 h-100 list-group rounded-top-0"></app-pickup-overview>
      <div class="flex-grow-0 flex-shrink-0 d-flex mx-4 my-2"
           [class.justify-content-center]="layout === 'mobile'"
           [class.justify-content-end]="layout === 'desktop'" *ngIf="pickupSelected">
        <button class="btn btn-info btn-lg text-white" *ngIf="pickupConfirmed" (click)="printReceipt(false)"
        >Kundenbeleg drucken
        </button>
        <button class="btn btn-info btn-lg text-white mx-3" *ngIf="pickupConfirmed" (click)="printReceipt(true)"
        >Händlerbeleg drucken
        </button>
        <button class="btn btn-info btn-lg text-white position-relative"
                *ngIf="!pickupConfirmed" (click)="completePickup()"
        >Bestätigen
        </button>
      </div>
    </ng-template>

    <ng-container *ngIf="layout === 'desktop'">
      <div class="modal-header">
        <h4 class="modal-title" id="exampleModalLabel" i18n>{{ headerText() }}</h4>
        <button type="button" class="btn-close" aria-label="Close" i18n-aria-label
                (click)="modalService.dismissAll()"></button>
      </div>
      <div class="modal-body d-flex p-0" [appLoadingOverlay]="loading">
        <div class="flex-column flex-grow-1 d-flex">
          <ng-template [ngTemplateOutlet]="pickupSelected ? pickupConfirmRef : templateRef"></ng-template>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="layout === 'mobile'">
      <div class="top"></div>
      <h2 i18n class="d-flex bg-white mb-0 ps-3 pb-2 pt-3 le-3">{{ headerText() }}</h2>
      <div class="d-flex flex-column flex-nowrap bg-white flex-shrink-1 h-25 flex-grow-1 bottom"
           [appLoadingOverlay]="loading">
        <ng-template [ngTemplateOutlet]="pickupSelected ? pickupConfirmRef : templateRef"></ng-template>
      </div>
    </ng-container>
  `,
    standalone: false
})
export class ReservationPage implements OnInit, OnDestroy {
  loading = false;
  buyingReservedArticle = false;
  selectedItem: PickupViewModel | null = null;
  productVariants: ProductVariant[] = [];
  pickupSelected = false;
  pickupConfirmed = false;
  pickupConfirmInProgress = false;
  completedPickup!: PickedUpResponse;
  pageCount = 2;
  pageCountPickupsAndReservations = 2;
  destroy = new Subject<void>();
  activeTab = 'offen';
  pickedups: PickupViewModel[] = [];
  pickupsAndReservations: PickupViewModel[] = [];

  private _pickedupLoadingOptions = new BehaviorSubject<Partial<PickedupLoadingOptions>>({
    page: 0,
  });

  private _pickupsAndReservationsLoadingOptions = new BehaviorSubject<Partial<PickedupLoadingOptions>>({
    page: 0,
  });

  constructor(@Inject(SCREEN_LAYOUT) public layout: ScreenLayout,
              public readonly modalService: NgbModal,
              private readonly dataService: DataService,
              private readonly printService: PrinterService
  ) {}

  get noDataText(): string {
    return this.activeTab === 'offen'
      ? 'Es gibt keine Reservierungen oder Click & Collect Bestellungen.'
      : 'Es liegen keine abgeschlossenen Bestellungen vor.';
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  async ngOnInit(): Promise<void> {
    try {
      this.loading = true;
      await this.dataService.fetchAllProducts();
      this.productVariants = this.dataService.products.flatMap(p => p.variants);

      await this.loadNextPage();
      await this.loadNextPagePickupsAndReservations();
    } finally {
      this.loading = false;
    }
  }

  async buyReservedProduct() {
    if (this.selectedItem === null) {
      return;
    }

    try {
      this.buyingReservedArticle = true;
      const { isReservation, id, email, items } = this.selectedItem;
      const products = items.map(({ product: { id, quantity } }) => ({ id, quantity }));

      if (isReservation) {
        await this.dataService.addReservedProductToCart(id, products, email, false);

        this.modalService.dismissAll();
      } else {
        this.pickupSelected = true;
      }
    } finally {
      this.buyingReservedArticle = false;
    }
  }

  toPickupViewModel(pickups: Pickup[] = []): PickupViewModel[] {
    return pickups.map((p: Pickup): PickupViewModel => {
      const items = p.items.map(({
        productId,
        productCode,
        productQuantity,
        productTitle,
        productPrice,
        option01,
        option02,
        option03,
      }): PickupItemViewModel => {
        const product: ProductVariant | undefined = this.productVariants.find(({ id }) => id === productId);

        return {
          product: {
            id: productId,
            code: productCode,
            quantity: productQuantity,
            title: productTitle,
            imageUrl: get(product, 'images[0].url') ?? undefined,
            price: productPrice,
          },
          options: [
            option01, option02, option03,
          ].filter((option): option is string => !!option),
        };
      });

      return {
        items: items,
        id: p.id,
        code: p.code,
        email: p.email,
        pickupAt: p.pickupAt,
        pickedAt: p.pickedAt,
        rawPickup: p,
        name: p.name,
        isReservation: p.isReservation,
        expiresAt: p.expiresAt,
        expanded: false,
      };
    });
  }

  isPickupViewModel(selectedItem : any): selectedItem is PickupViewModel {
    return 'rawPickup' in selectedItem;
  }

  headerText() {
    return this.pickupSelected ? 'Abholung bestätigen' : 'Abholung';
  }

  private async fetchPaginatedPickupsAndReservations(): Promise<PickupViewModel[]> {
    try {
      const p = this._pickupsAndReservationsLoadingOptions.getValue().page ?? 1;

      this.loading = true;
      const paginatedPickupsAndReservations = await this.dataService.fetchPaginatedPickupsAndReservations({ p });

      this.pageCountPickupsAndReservations = paginatedPickupsAndReservations.meta.total;
      return this.toPickupViewModel(paginatedPickupsAndReservations.pickups);
    } finally {
      this.loading = false;
    }
  }

  private async fetchPickedups(): Promise<PickupViewModel[]> {
    try {
      const p = this._pickedupLoadingOptions.getValue().page ?? 1;

      this.loading = true;
      const paginatedPickedups = await this.dataService.fetchPaginatedPickedups({ p });
      this.pageCount = paginatedPickedups.meta.total;
      return this.toPickupViewModel(paginatedPickedups.pickups);
    } finally {
      this.loading = false;
    }
  }

  private addPickedups(pickedups: PickupViewModel[]) {
    this.pickedups = this.pickedups.concat(pickedups);

    // Sort all picked-up orders by pickedAt date descending (newest first)
    this.pickedups.sort((a, b) => {
      // If both don't have pickedAt - keep current order
      if (!a.pickedAt && !b.pickedAt) return 0;

      // If only a doesn't have pickedAt - move a to the end
      if (!a.pickedAt) return 1;

      // If only b doesn't have pickedAt - move b to the end
      if (!b.pickedAt) return -1;

      // Both have pickedAt - sort descending (newest first)
      return b.pickedAt.toMillis() - a.pickedAt.toMillis();
    });
  }

  private addPickupsAndReservations(pickupsAndReservations: PickupViewModel[]) {
    this.pickupsAndReservations = this.pickupsAndReservations.concat(pickupsAndReservations);
  }

  async completePickup() {
    try {
      this.pickupConfirmInProgress = true;
      this.completedPickup = await this.dataService.completePickup(this.selectedItem!.id);
      this.pickupConfirmed = true;
    } finally {
      this.pickupConfirmInProgress = false;
    }
  }

  async printReceipt(merchantReceipt: boolean) {
    const { receiptUrl, receiptImageUrl, receiptEposUrl } = this.completedPickup;

    await this.printService.printReceipt(receiptUrl, receiptImageUrl, receiptEposUrl, merchantReceipt);
  }

  async loadNextPagePickupsAndReservations() {
    const currentPage = this._pickupsAndReservationsLoadingOptions.getValue().page ?? 0;

    if (currentPage >= this.pageCountPickupsAndReservations) {
      return;
    }

    this._pickupsAndReservationsLoadingOptions.next({page: currentPage + 1});
    const pickupsAndReservations = await this.fetchPaginatedPickupsAndReservations();

    // add items to list
    this.addPickupsAndReservations(pickupsAndReservations);
  }

  async loadNextPage() {
    const currentPage = this._pickedupLoadingOptions.getValue().page ?? 0;

    if (currentPage >= this.pageCount) {
      return;
    }

    this._pickedupLoadingOptions.next({page: currentPage + 1});
    const pickedups = await this.fetchPickedups();

    // add items to list
    this.addPickedups(pickedups);
  }

  async deleteReservation() {
    if (!this.selectedItem?.isReservation) {
      return;
    }

    const modalRef = this.modalService.open(ConfirmDeleteComponent, {
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.title = 'Reservierung löschen';
    modalRef.componentInstance.message = 'Sind Sie sicher, dass Sie die Reservierung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.';
    modalRef.componentInstance.confirmButtonText = 'Reservierung löschen';
    modalRef.componentInstance.cancelButtonText = 'Abbrechen';

    const confirmed = await modalRef.result.then(result => result, () => false);

    if (!confirmed) {
      return;
    }
    this.buyingReservedArticle = true;
    await this.dataService.deleteReservation(this.selectedItem!.id);
    this.dataService.reservationsAndPickupsCount--;

    this.pickupsAndReservations = this.pickupsAndReservations.filter(item => item.id !== this.selectedItem!.id);
    this.selectedItem = null;
    this.buyingReservedArticle = false;
  }
}
